import { useQuery } from '@tanstack/react-query';
import { apiWrapper } from '@/apiWrapper';
import { getEndpoints } from '@/endpoints';
import type { Destination } from '@/features/destinations/utils/Destination';

const getDestinations = async (
  isLuxury?: boolean,
  useNewDest?: boolean,
): Promise<Destination[]> => {
  const url = isLuxury
    ? getEndpoints().luxuryDestinations
    : getEndpoints().destinations;
  const config = {
    method: 'GET',
    params: useNewDest ? { useNewDest: 'true' } : undefined,
  };

  return await apiWrapper<Destination[]>(url, config);
};

export const useDestinations = (isLuxury?: boolean, useNewDest?: boolean, featureFlagsReady?: boolean) => {
  return useQuery({
    queryKey: ['destinations', isLuxury, useNewDest],
    queryFn: () => getDestinations(isLuxury, useNewDest),
    staleTime: Number.POSITIVE_INFINITY,
    enabled: featureFlagsReady !== false,
  });
};
